import { bl_fi_entity_calendar_event_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class FinancialEntityCalendarEventContainerModel extends BaseContainerModel {
  bl_fi_entity_calendar_event_hdr: bl_fi_entity_calendar_event_hdr_RowClass = new bl_fi_entity_calendar_event_hdr_RowClass();
}
